import AddAlternatedMaterial from "@saleor/alternatedMaterial/components/AddAlternatedMaterial";
import EditAlternatedMaterial from "@saleor/alternatedMaterial/components/EditAlternatedMaterial";
import {
  addAlternatedMaterialUrl,
  alternatedMaterialUrl,
  AltMatSortField,
  AltMatUrlQueryParams,
  editdAlternatedMaterialUrl,
  logChangeUrl
} from "@saleor/alternatedMaterial/urls";
import AlternatedMaterialView from "@saleor/alternatedMaterial/views/AlternatedMaterialView";
import LogChangeView from "@saleor/alternatedMaterial/views/LogChangeView";
import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

const AlternatedMaterialSection = () => {
  const intl = useIntl();

  const AlternatedMaterialComponent: React.FC<RouteComponentProps<any>> = ({
    location
  }) => {
    const qs = parseQs(location.search.substr(1));
    const params: AltMatUrlQueryParams = asSortParams(qs, AltMatSortField);
    return <AlternatedMaterialView params={params} />;
  };
  const AddAlternatedMaterialComponent: React.FC<RouteComponentProps<
    any
  >> = () => <AddAlternatedMaterial />;
  const LogChangeComponent: React.FC<RouteComponentProps<any>> = () => (
    <LogChangeView />
  );

  const EditAlternatedMaterialComponent: React.FC<RouteComponentProps<
    any
  >> = () => <EditAlternatedMaterial />;

  return (
    <>
      <WindowTitle
        title={intl.formatMessage(sectionNames.alternatedMaterial)}
      />
      <Switch>
        <Route
          exact
          path={alternatedMaterialUrl}
          render={AlternatedMaterialComponent}
        />
        <Route
          exact
          path={addAlternatedMaterialUrl}
          render={AddAlternatedMaterialComponent}
        />
        <Route exact path={logChangeUrl} render={LogChangeComponent} />
        <Route
          exact
          path={editdAlternatedMaterialUrl}
          render={EditAlternatedMaterialComponent}
        />
      </Switch>
    </>
  );
};

export default AlternatedMaterialSection;
